import { format } from 'date-fns';
import ListTableMainCell from '../../../components/list-table-main-cell/list-table-main-cell.component';
import { displayCellValue } from '../../../utils/column-values.util';

export const HELP_UPDATES_COLUMNS = [
    {
        Header: "Title",
        accessor: "title",
        style: {
            position: "sticky",
            left: 0,
            top: 0,
            zIndex: 2
        },
        Cell: ({ value, row }) => {
            const uuid = row.original.uuid;
            return (
                <ListTableMainCell
                    value={value}
                    uuid={uuid}
                />
            )
        }
    },
    {
        Header: "Tag",
        accessor: "tag",
        Cell: ({ value }) => displayCellValue(value)
    },
    {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => value ? format(new Date(value), 'dd/MM/yyyy') : ''
    },
    {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => displayCellValue(value)
    },
]
